"use client";

import React from "react";
import { Phone, PartyPopper } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BookingCTA() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="bookingcta" className="bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 overflow-hidden relative">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-20">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-full bg-primary/20 blur-3xl" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-full blur-3xl" style={{
        backgroundColor: "var(--color-gold)"
      }} />
      </div>

      <div ref={ref} className={`max-w-4xl mx-auto text-center relative z-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        {}
        <div className="inline-flex items-center justify-center gap-3 bg-primary text-primary-foreground px-6 py-3 rounded-full font-default font-bold tracking-wide text-sm md:text-base mb-10 shadow-lg" style={{
        boxShadow: "0 4px 12px rgba(217, 79, 0, 0.3)"
      }}>
          <PartyPopper className="w-5 h-5" />
          <span>SPECIAL OFFER: 15% OFF YOUR FIRST EVENT BOOKING</span>
        </div>

        {}
        <h2 className="font-serif text-6xl md:text-8xl lg:text-9xl tracking-wider mb-8 leading-none">
          WANT TO HOST <span className="text-primary block md:inline">HERE?</span>
        </h2>

        {}
        <p className="font-default text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-12 leading-relaxed">
          From intimate gatherings to full restaurant buyouts, Sultani Grill & Burgers is the perfect venue for your next event. Enjoy our bold Punjabi-American fusion menu in a modern, vibrant setting that your guests won't forget.
        </p>

        {}
        <div className="mb-10">
          <p className="font-default text-sm text-muted-foreground uppercase tracking-widest mb-2">
            Call us directly to reserve
          </p>
          <Link to="tel:972-600-9309" className="text-[var(--color-gold)] font-serif text-5xl md:text-7xl tracking-wider hover:text-primary transition-colors duration-300 inline-block">
            972-600-9309
          </Link>
        </div>

        {}
        <Button asChild size="lg" className="rounded-full bg-primary text-primary-foreground hover:bg-primary/90 text-lg md:text-xl px-10 py-8 font-serif tracking-wider transition-transform hover:scale-105">
          <Link to="tel:972-600-9309">
            <Phone className="w-6 h-6 mr-2" />
            DIAL NOW TO BOOK
          </Link>
        </Button>
      </div>
    </section>;
}